import { writable, derived, get } from 'svelte/store'

export interface User {
  id: number
  email: string
  role: 'ADMIN' | 'MANAGER' | 'REVIEWER' | 'VIEWER'
}

interface Session {
  accessToken: string | null
  user: User | null
}

export const session = writable<Session>({ accessToken: null, user: null })
export const isAuthenticated = derived(session, ($s) => $s.accessToken !== null)
export const currentRole = derived(session, ($s) => $s.user?.role ?? null)

export function setSession(accessToken: string, user: User): void {
  session.set({ accessToken, user })
}

export function clearSession(): void {
  session.set({ accessToken: null, user: null })
}

export function getAccessToken(): string | null {
  return get(session).accessToken
}
